export const ALLOWED_IPS = [
  "49.43.230.51",
  "162.120.184.12",
  "163.223.49.143"
];

export const getPublicIP = async () => {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    return data.ip;
  } catch (err) {
    console.error("Failed to fetch IP", err);
    return null;
  }
};

export const isWhitelistedIP = async () => {
  const ip = await getPublicIP();
   console.log("Current Public IP:", ip);
  return ALLOWED_IPS.includes(ip);
};